_ = require('underscore')

module.exports = require('vue/dist/vue').extend

  created: ->
    return unless _.isFunction(@.$options.template)

    data = @serializeData() if _.isFunction(@serializeData)
    data or= {}

    @.$options.template = @.$options.template(data)


// WEBPACK FOOTER //
// ./assets/js/frontend/components/abstract/index.coffee